import type { SVGProps } from "react";
export default function SvgSquare(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-square-icon lucide-square"
			viewBox="0 0 24 24"
			{...props}
		>
			<rect width={18} height={18} x={3} y={3} rx={2} />
		</svg>
	);
}
